import React from 'react'

export interface PaddingProps {
  paddingLeft: number
  paddingRight: number
}

interface PaddingContextProps {
  padding?: PaddingProps
}

const defaultValue: PaddingContextProps = {}

const PaddingContext = React.createContext(defaultValue)
export default PaddingContext

export interface SetPaddingProps {
  setPadding: (value?: PaddingProps) => void
}
